export const shouldHideCartPeekToast = (variant: string, cartCount: number): boolean => {
  if (variant === 'atc-a') {
    return true;
  }

  if (variant === 'atc-b') {
    // Hide toast when cart already had items before this ATC
    return cartCount >= 1;
  }

  return false;
};

export const shouldShowCartPeekNudge = (
  variant: string,
  cartCountAfterAtc: number,
  minCartCountAfterAtc?: number
): boolean => {
  if (variant === 'atc-a') {
    return true;
  }

  if (variant === 'atc-b') {
    if (minCartCountAfterAtc === undefined) {
      return false;
    }

    return cartCountAfterAtc >= minCartCountAfterAtc;
  }

  return false;
};
